export default __webpack_public_path__ + "images/0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f.png";